import { Platform } from 'react-native';
import callNative from '../../../callNative';
import canUseBridge from '../../../canUseBridge';
import { stringify } from 'qs';
import crypto, { objectToStr } from '../../../cryptoWithParam';
import getCookies from '../../../getCookies';
import getDeviceInfo from '../../../getDeviceInfo';
import getEnv from '../../../getEnv';
import getUrlParam from '../../../getUrlParams';
import isInKwaiying from '../../../isInKwaiying';
import { clearEmptyParam } from '../../../utils';
const isWeb = Platform.OS === 'web';
const isInYt = process.env.APP === 'm2u';
export const headerList = [
    {
        nameKey: 'os',
        valueKey: 'platform',
    },
    {
        nameKey: 'version',
        valueKey: 'appVersion',
    },
    {
        nameKey: 'mod',
        valueKey: 'model',
    },
    {
        nameKey: 'kProjectVersion',
        valueKey: 'kProjectVersion',
    },
];
export const injectHeaders = function (headers = {}, env, deviceInfo) {
    if (env.direct) {
        headers.direct = '1';
    }
    if (env.laneId) {
        headers['trace-context'] = JSON.stringify({ laneId: env.laneId });
    }
    headerList.forEach(({ nameKey, valueKey }) => {
        if (typeof deviceInfo[valueKey] !== 'undefined') {
            headers[nameKey] = deviceInfo[valueKey];
        }
    });
    return headers;
};
export async function request(config, next) {
    // 兼容部分body的写法
    // @ts-ignore
    config.data = config.data || config.body;
    let { headers, params, baseURL } = config;
    const [env, deviceInfo, cookie] = await Promise.all([
        getEnv(),
        getDeviceInfo(),
        getCookies(),
    ]);
    if (!baseURL) {
        config.baseURL = env.url;
    }
    // param
    const testParams = {};
    if (env.type === 1) {
        testParams.isTest = 1;
    }
    let webExtra = {};
    if (isWeb) {
        const did = cookie.did || cookie._did;
        webExtra = {
            did: isInKwaiying() ? did : getUrlParam('tk'),
            webId: did,
            userId: cookie.userId,
            'ky.api_st': cookie['ky.api_st'],
        };
    }
    const extraData = {
        ...testParams,
        ...webExtra,
    };
    config.params = clearEmptyParam(params
        ? {
            ...extraData,
            ...params,
        }
        : extraData);
    // @ts-ignore
    if (config.disableSign !== true && !isInYt) {
        config.params.tempAcceptType = 1;
        const accessSecret = 'yiuhjkbvhbjisjchgdnx38uejd';
        const cryptoData = crypto(accessSecret, config.params);
        if (canUseBridge('atlasSign')) {
            try {
                const { timestamp, nonce } = cryptoData;
                const params = {
                    ...config.params,
                    timestamp,
                    nonce,
                };
                let originString = objectToStr(params);
                originString += '&accessSecret=' + accessSecret;
                if (config.method === 'POST') {
                    const body = config.data || {};
                    originString += '&body=' + JSON.stringify(body);
                }
                const sig3 = await callNative('atlasSign', {
                    params: {
                        originString,
                    },
                    checkError: true,
                    timeout: 0,
                });
                config.params.sig3 = sig3;
            }
            catch (error) {
                console.log('atlasSign error', error);
            }
        }
        config.params = {
            ...cryptoData,
            ...config.params,
        };
    }
    if (isInYt) {
        config.params = {
            ve: cookie.appVersion || cookie.appver,
            ...cookie,
            ...config.params,
        };
    }
    // header
    if (isInKwaiying()) {
        config.headers = injectHeaders(headers, env, deviceInfo);
    }
    else {
        config.headers = config.headers || {};
    }
    if (!isWeb) {
        config.headers = Object.assign(config.headers, {
            cookie: stringify(cookie, { delimiter: '; ' }), // cookie 不准确
        });
    }
    await next();
}
